export default __webpack_public_path__ + "static/media/brownie.c4357af8.jpg";